import React from 'react'
const TableHeader = ({ title }) => (
  <h4 style={{ fontWeight: 'bold', marginTop: 15, color: '#000' }}>{title}</h4>
)

export default TableHeader
